// dependencies.
import { RotatingLines } from 'react-loader-spinner'
import styled from 'styled-components'
import { theme } from '../../styleguide'

/*******************************/
/*                             */
/*    Loader Icon Component    */
/*                             */
/*******************************/

// partials.
const Wrapper = styled.div(({ isPage }) => ({
  width: '100%',
  minHeight: isPage ? '40vh' : '88px',
  margin: '0 auto',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '10px',
}))

const Label = styled.span({
  color: theme.colors.grey,
  fontSize: '13px',
  lineHeight: '16px',
  letterSpacing: '0.02em',
  fontFamily: 'Roboto, sans-serif',
  fontWeight: 400,
})

// main component.
const Loader = ({ className, isPage = false }) => {
  // ------------------------------------------------------------------------------------------- //
  // CONTENT                                                                                     //
  // ------------------------------------------------------------------------------------------- //

  // return content.
  return (
    <Wrapper className={className} isPage={isPage}>
      <RotatingLines
        strokeColor={theme.colors.primary}
        strokeWidth="4"
        animationDuration="0.85"
        width="42"
        visible="true"
      />
      <Label>Cargando...</Label>
    </Wrapper>
  )
}

export default Loader
